import { useRouter } from 'next/router'
import React from 'react'

import logger from '@/utils/logger'

const QUERY_LIMIT_UNIT = 24
export const QUERY_LIMIT_MAX = 500

export function useInfiniteScroll({
  queryKey = 'limit',
  defaultValue = QUERY_LIMIT_UNIT,
  additionalToShow,
}: {
  queryKey?: string
  defaultValue?: number
  additionalToShow?: number
} = {}): [number, () => void, string] {
  const router = useRouter()

  const queryLimit = Math.min(
    Number.parseInt(
      String(router.query[queryKey] == null ? defaultValue : router.query[queryKey]),
      10
    ),
    QUERY_LIMIT_MAX
  )

  const handleLoadMore = React.useCallback(() => {
    const query = {
      ...router.query,
      [queryKey]: `${queryLimit + (additionalToShow ?? defaultValue)}`,
    }
    router.replace({ query }, undefined, { scroll: false }).catch(err => {
      logger.error('Navigation failed', { err })
    })
  }, [router, queryKey, queryLimit, additionalToShow, defaultValue])

  const { [queryKey]: _limit, ...rest } = router.query as Record<string, string>
  const showAllPath = `${router.basePath}?${new URLSearchParams(rest).toString()}`

  return [queryLimit, handleLoadMore, showAllPath]
}
